export const SESSIONS_STATES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ACTIVATED: 'Activated',
  EXPIRED: 'Expired',
};
